import { useEffect } from "react";
import { Link } from "react-router-dom";

const VARIANTS = [
  {
    slug: "a",
    name: "Editorial",
    sub: "Quiet luxury",
    desc: "Single-column reading flow. Oversized serif. Heavy negative space. Drop-cap section starts. Feels like a magazine essay.",
    bg: "bg-[#fafaf7]",
    text: "text-coffee-900",
    accent: "italic",
  },
  {
    slug: "b",
    name: "Product",
    sub: "Linear / Stripe energy",
    desc: "Tight bento grids everywhere. Mix of dark and light sections. Real-feeling product UI mockups. Live tap counter, mini stats card. Info-dense.",
    bg: "bg-white",
    text: "text-coffee-900",
    accent: "",
  },
  {
    slug: "c",
    name: "Playful",
    sub: "Cal.com energy",
    desc: "Interactive theme switcher under the card preview. Rotating role word in the headline. Tap-flow strip. More motion, more personality.",
    bg: "bg-white",
    text: "text-coffee-900",
    accent: "",
  },
  {
    slug: "d",
    name: "Guided tour",
    sub: "Hover-to-explore",
    desc: "Card front-and-center. Hover any element (avatar, title, links, dashboard tiles) and a side popover explains the capability + offers a Claim CTA. The product itself becomes the landing.",
    bg: "bg-white",
    text: "text-coffee-900",
    accent: "",
  },
];

export default function LandingPreviewIndex() {
  useEffect(() => {
    document.title = "Landing previews — pick one";
  }, []);

  return (
    <div className="min-h-screen bg-white text-coffee-900 py-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="eyebrow mb-3">Internal · pick a direction</div>
        <h1 className="text-display text-4xl sm:text-5xl mb-3">Three takes on the landing.</h1>
        <p className="text-coffee-700 text-lg mb-12">
          Three full landings, each its own visual personality. Open each, scroll, click around. The
          one you pick gets promoted to <code className="font-mono text-sm bg-coffee-50 border border-coffee-100 rounded px-1.5 py-0.5">/</code>.
        </p>
        <div className="space-y-3">
          {VARIANTS.map((v) => (
            <Link
              key={v.slug}
              to={`/preview/${v.slug}`}
              className="block bg-white border border-coffee-100 rounded-2xl p-6 hover-lift transition-all"
            >
              <div className="flex items-baseline gap-3 mb-2">
                <span className="text-[11px] font-mono text-coffee-500">/{v.slug}</span>
                <h2 className="text-display text-2xl text-coffee-900">{v.name}</h2>
                <span className={`text-coffee-600 ${v.accent}`}>{v.sub}</span>
              </div>
              <p className="text-sm text-coffee-600 leading-relaxed">{v.desc}</p>
              <span className="mt-4 inline-flex items-center text-sm text-coffee-700 font-medium">
                Open →
              </span>
            </Link>
          ))}
        </div>
        <div className="mt-12 pt-8 border-t border-coffee-100 text-sm text-coffee-500">
          <p>Current live landing stays at <Link to="/" className="text-coffee-700 underline">/</Link> until you pick one.</p>
        </div>
      </div>
    </div>
  );
}
